export default __webpack_public_path__ + "static/2-d373251d433b4ea6e727c48359223ea3.png";